export const SOKOLOV_COMPANY_SLUG = 'sokolov'
export const SKLVC_COMPANY_SLUGS = ['sklvc', 'demo']
export const SMARTCAT_COMPANY_SLUG = 'smartcat'
export const YANGO_COMPANY_SLUG = 'yango'
export const KODLAND_COMPANY_SLUG = 'kodland'
export const VISTA_COMPANY_SLUG = 'vista'
export const AESTHETEMED_COMPANY_SLUG = 'aesthetemed'
export const NOKIAN_TYRES_COMPANY_SLUGS = ['nokian_tyres', 'ikon_tyres']
export const JACK_POKER_COMPANY_SLUG = 'jack_poker'
export const HUMANOID_COMPANY_SLUG = 'humanoid'
export const XPATE_COMPANY_SLUG = 'xpate'

export const ARTIFIC_COMPANY_SLUGS = [
  SOKOLOV_COMPANY_SLUG,
  ...SKLVC_COMPANY_SLUGS,
  SMARTCAT_COMPANY_SLUG,
  YANGO_COMPANY_SLUG,
  KODLAND_COMPANY_SLUG,
  VISTA_COMPANY_SLUG,
  AESTHETEMED_COMPANY_SLUG,
  ...NOKIAN_TYRES_COMPANY_SLUGS,
  JACK_POKER_COMPANY_SLUG,
  HUMANOID_COMPANY_SLUG,
  XPATE_COMPANY_SLUG
]
